import { useEffect, useCallback } from 'react';

export enum EventName {
  NOTIFICATION_PERMISSION = 'NOTIFICATION_PERMISSION',
}

interface EventDetailMap {
  [EventName.NOTIFICATION_PERMISSION]: boolean;
}

function useCustomEvent<T extends EventName>(
  eventName: T,
  onEvent?: (e: CustomEvent<EventDetailMap[T]>) => void,
  target = window
) {
  const dispatch = useCallback(
    (detail: EventDetailMap[T]) => {
      const event = new CustomEvent(eventName, { detail });
      target.dispatchEvent(event);
    },
    [eventName, target]
  );

  useEffect(() => {
    if (!onEvent) return;

    const handler = e => onEvent(e as CustomEvent<EventDetailMap[T]>);

    target.addEventListener(eventName, handler);
    // eslint-disable-next-line consistent-return
    return () => {
      target.removeEventListener(eventName, handler);
    };
  }, [eventName, onEvent, target]);

  return dispatch;
}

export default useCustomEvent;
